import authAxios from "../common/authAxios";
import { CounterpartyActivityClassifierDtoRequest, CounterpartyActivityClassifierDtoResponse, CounterpartyAgreementDtoRequest, CounterpartyAgreementDtoResponse, CounterpartyDtoRequest, CounterpartyDtoResponse, CounterpartyFormDto } from "../interfaces/CounterpartyDtos";
import { DictionaryCatalogDtoResponse } from "../interfaces/DictionaryCatalogDtoResponse";

export class CounterpartyService {

    static async getCounterparties(search?: string) {
        return authAxios.get<CounterpartyDtoResponse[]>('/office-service/api/v1/counterparties', {
            params: { search }
        });
    }

    static async createCounterparty(data: CounterpartyDtoRequest) {
        return authAxios.post('/office-service/api/v1/counterparties', data);
    }

    static async updateCounterparty(id: number, data: CounterpartyDtoRequest) {
        return authAxios.put(`/office-service/api/v1/counterparties/${id}`, data);
    }

    static async deleteCounterparty(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/${id}`);
    }

    //Forms
    static async getCounterpartyForms() {
        return authAxios.get<CounterpartyFormDto[]>('/office-service/api/v1/counterparties/forms');
    }

    static async createCounterpartyForm(data: CounterpartyFormDto) {
        return authAxios.post('/office-service/api/v1/counterparties/forms', data);
    }

    static async updateCounterpartyForm(id: number, data: CounterpartyFormDto) {
        return authAxios.put(`/office-service/api/v1/counterparties/forms/${id}`, data);
    }

    static async deleteCounterpartyForm(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/forms/${id}`);
    }

    //AgreementTypes
    static async getCounterpartyAgreementTypes() {
        return authAxios.get<DictionaryCatalogDtoResponse[]>('/office-service/api/v1/counterparties/agreement-types');
    }

    static async createCounterpartyAgreementType(data: DictionaryCatalogDtoResponse) {
        return authAxios.post('/office-service/api/v1/counterparties/agreement-types', data);
    }

    static async updateCounterpartyAgreementType(id: number, data: DictionaryCatalogDtoResponse) {
        return authAxios.put(`/office-service/api/v1/counterparties/agreement-types/${id}`, data);
    }

    static async deleteCounterpartyAgreementType(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/agreement-types/${id}`);
    }

    //Agreements
    static async getCounterpartyAgreements() {
        return authAxios.get<CounterpartyAgreementDtoResponse[]>('/office-service/api/v1/counterparties/agreements');
    }

    static async createCounterpartyAgreement(data: FormData) {
        return authAxios.post('/office-service/api/v1/counterparties/agreements', data);
    }

    static async updateCounterpartyAgreement(id: number, data: FormData) {
        return authAxios.put(`/office-service/api/v1/counterparties/agreements/${id}`, data);
    }

    static async deleteCounterpartyAgreement(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/agreements/${id}`);
    }

    //Activity classifier
    static async getActivityClassifier() {
        return authAxios.get<CounterpartyActivityClassifierDtoResponse[]>('/office-service/api/v1/counterparties/activity-classifiers');
    }

    static async createActivityClassifier(data: CounterpartyActivityClassifierDtoRequest) {
        return authAxios.post('/office-service/api/v1/counterparties/activity-classifiers', data);
    }

    static async updateActivityClassifier(id: number, data: CounterpartyActivityClassifierDtoRequest) {
        return authAxios.put(`/office-service/api/v1/counterparties/activity-classifiers/${id}`, data);
    }

    static async deleteActivityClassifier(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/activity-classifiers/${id}`);
    }

    //Classifier
    static async getClassifiers() {
        return authAxios.get<DictionaryCatalogDtoResponse[]>('/office-service/api/v1/counterparties/classifiers');
    }

    static async createClassifier(data: DictionaryCatalogDtoResponse) {
        return authAxios.post('/office-service/api/v1/counterparties/classifiers', data);
    }

    static async updateClassifier(id: number, data: DictionaryCatalogDtoResponse) {
        return authAxios.put(`/office-service/api/v1/counterparties/classifiers/${id}`, data);
    }

    static async deleteClassifier(id: number) {
        return authAxios.delete(`/office-service/api/v1/counterparties/classifiers/${id}`);
    }
}